var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',{ref:"table",staticStyle:{"width":"100%"},attrs:{"data":_vm.filterItems(_vm.items)},on:{"row-click":_vm.openItem,"selection-change":_vm.handleSelectionChange}},[_vm._t("rows",null,{"data":_vm.items})],2)}
var staticRenderFns = []

export { render, staticRenderFns }